import TabPage from '@/components/TabPage';

export default function DailyShipment() {
  return <TabPage chartFullKeys={['customer_trend', 'channel_trend']} />;
}
